import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Container } from 'react-bootstrap'
import V2Layout from '../components/V2Layout'
import axios from 'axios'

const API = ''

function formatDate(d) {
    if (!d) return ''
    return new Date(d + 'Z').toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
}

const NewsScreenV2 = () => {
    const [articles, setArticles] = useState([])

    useEffect(() => {
        axios.get(`${API}/api/news`).then(r => setArticles(r.data)).catch(() => { })
    }, [])

    return (
        <V2Layout pageClass="pfc-products">
            <section style={{ padding: '3rem 0 5rem', backgroundColor: 'var(--v2-bg)', minHeight: '80vh' }}>
                <Container style={{ maxWidth: '800px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
                        <div>
                            <p className="v2-section-label" style={{ color: 'var(--v2-text2)' }}>Latest Updates</p>
                            <h1 style={{ color: 'var(--v2-text)', margin: 0 }}>News</h1>
                        </div>
                        <Link to="/news" style={{ color: 'var(--v2-primary)', fontSize: '0.875rem' }}>Card View →</Link>
                    </div>

                    {articles.length === 0 ? (
                        <p style={{ color: 'var(--v2-text3)', textAlign: 'center', padding: '3rem 0' }}>No news articles yet.</p>
                    ) : (
                        articles.map(a => (
                            <article key={a.id} style={{ marginBottom: '3rem', paddingBottom: '3rem', borderBottom: '1px solid var(--v2-border)' }}>
                                <small style={{ color: 'var(--v2-text2)' }}>{formatDate(a.created_at)}</small>
                                <h2 style={{ color: 'var(--v2-text)', fontSize: '1.5rem', margin: '0.5rem 0 1rem' }}>{a.title}</h2>
                                {a.header_image && (
                                    <div style={{ marginBottom: '1.5rem', borderRadius: '4px', overflow: 'hidden' }}>
                                        <img src={`${API}${a.header_image}`} alt={a.title} style={{ width: '100%', maxHeight: '400px', objectFit: 'cover' }} />
                                    </div>
                                )}
                                <div style={{ color: 'var(--v2-text)', fontSize: '0.9375rem', lineHeight: 1.7 }} dangerouslySetInnerHTML={{ __html: a.body }} />
                                <Link to={`/news/${a.id}`} style={{ color: 'var(--v2-primary)', fontSize: '0.85rem', fontWeight: 600 }}>Permalink →</Link>
                            </article>
                        ))
                    )}
                </Container>
            </section>
        </V2Layout>
    )
}

export default NewsScreenV2
